module.exports = __webpack_public_path__ + "img/account-money.71646547.svg";